// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"08d1c2af","867":"412415c8"}[chunkId] + ".chunk.js";
};